import React, { lazy, Suspense, useState } from 'react'
import { showEx, setEx } from './core'

const Experiments = lazy(() => import('./Experiments'))

const hasWindow = typeof window !== 'undefined'
const win = hasWindow ? window : {}

export default function ExperimentsLoader() {
  const [isOpen, setIsOpen] = useState(() => {
    if (hasWindow) {
      const url = win.location.href
      const listEx = new URL(url).searchParams.get('listEx')
      if (listEx || listEx === '') {
        return true
      }
    }
    return false
  })

  if (hasWindow) {
    win.FS = win.FS || {}
    win.FS.listEx = () => {
      setIsOpen(true)
    }
    win.FS.showEx = showEx
    win.FS.setEx = setEx
  }

  return <Suspense fallback={null}>{isOpen && <Experiments setIsOpen={setIsOpen} isOpen={isOpen} />}</Suspense>
}
